const main_url = import.meta.env.VITE_BROKER_URL

export default main_url;
